import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconClose = createIcon({
  displayName: 'IconClose',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M19.2979 3.28844L3.29607 19.2903L4.71028 20.7045L20.7121 4.70266L19.2979 3.28844ZM4.71017 3.29133L3.29596 4.70555L9.17202 10.5816L10.5862 9.16739L4.71017 3.29133ZM13.4078 14.8255L14.822 13.4113L20.6981 19.2874L19.2839 20.7016L13.4078 14.8255Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
